<template>
    <div class="shared-records-message">
        <h2>{{ sharedByName }} shared {{ documentCount }} document(s) with you</h2>
        <p>{{ $t('pages.public.shared_records.gate_intro') }}</p>

        <div v-if="view === 'menu'" class="gate-actions">
            <common-buttons align="center">
                <common-button
                    v-if="requiresAccessCode"
                    :label="$t('pages.public.shared_records.continue_as_guest')"
                    type="primary"
                    @click="$emit('change-view', 'guest')"
                ></common-button>
                <common-button
                    :label="$t('pages.public.shared_records.log_in')"
                    :type="requiresAccessCode ? 'secondary' : 'primary'"
                    @click="$emit('login')"
                ></common-button>
                <common-button
                    :label="$t('pages.public.shared_records.create_account')"
                    type="secondary"
                    @click="$emit('change-view', 'signup')"
                ></common-button>
            </common-buttons>
        </div>

        <shared-records-guest-code-form
            v-else-if="view === 'guest'"
            :token="token"
            @verified="$emit('guest-verified', $event)"
            @back="$emit('change-view', 'menu')"
        ></shared-records-guest-code-form>

        <shared-records-temp-account-form
            v-else-if="view === 'signup'"
            :recipientEmail="recipientEmail"
            @authenticated="$emit('authenticated')"
            @back="$emit('change-view', 'menu')"
        ></shared-records-temp-account-form>
    </div>
</template>

<script>
    import SharedRecordsGuestCodeForm from './SharedRecordsGuestCodeForm'
    import SharedRecordsTempAccountForm from './SharedRecordsTempAccountForm'

    export default {
        components: {
            SharedRecordsGuestCodeForm,
            SharedRecordsTempAccountForm,
        },

        props: {
            token: { type: String, required: true },
            sharedByName: { type: String, default: '' },
            documentCount: { type: Number, default: 0 },
            requiresAccessCode: { type: Boolean, default: false },
            recipientEmail: { type: String, default: null },
            view: { type: String, default: 'menu' },
        },
    }
</script>

<style scoped lang="scss">
    .shared-records-message {
        text-align: center;
        padding: 40px 20px;

        p {
            margin-bottom: 32px;
        }
    }

    .gate-actions {
        display: flex;
        justify-content: center;
    }
</style>
